import React from "react";
import { createPortal } from "react-dom";
import DialogComponent from "./component";

interface IProps {
  open: boolean;
  onClose(): void;
}

const Dialog = (props: React.PropsWithChildren<IProps>) => {
  return props.open
    ? createPortal(<DialogComponent {...props} />, document.body)
    : null;
};

export default Dialog;
